<template>
  <BaseField
    ref="field"
    v-bind="attributes"
    v-on="$listeners"
  />
</template>

<script>
import BaseField from '@/components/BaseField.vue';

export default {
  name: 'FieldName',
  inheritAttrs: false,
  components: {
    BaseField,
  },
  computed: {
    attributes() {
      return {
        type: 'text',
        label: this.$t('fields.fullnameLabel'),
        placeholder: this.$t('fields.fullnamePlaceholder'),
        errorMessage: this.$t('fields.fullnameError'),
        required: true,
        ...this.$attrs,
      };
    },
  },
  methods: {
    focus() {
      return this.$refs.field?.focus();
    },
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    checkHasValue() {
      return this.$refs.field?.checkHasValue();
    },
  },
};
</script>
